var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floated-colors-btn third-floated-btn",on:{"click":_vm.darkMode}},[_vm._m(0),_c('span',[_vm._v("Dark ")]),_c('span',[_vm._v("Color")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"os-toggler-w"},[_c('div',{staticClass:"os-toggler-i"},[_c('div',{staticClass:"os-toggler-pill"})])])
}]

export { render, staticRenderFns }